// extracted by mini-css-extract-plugin
module.exports = {"container":"Pagination_container__1_N3e","number":"Pagination_number__3FGNG","selected":"Pagination_selected__uB5ps"};